module.exports = __webpack_public_path__ + "static/CleverQuality-384c200d29031d678c13248dc28e0af5.png";